import raf from 'raf'
import { useEffect, useRef } from 'react'
import { registerPageScrollEventListener } from '@jarvis.oddle/core/tools/bodyScrolling'
import { isBrowser } from '@jarvis.oddle/core/env'

const computePageScrollPercentage = (): number => {
  if (!isBrowser()) return 0
  const documentElement = document.documentElement
  const body = document.body
  const scrollTop = documentElement.scrollTop || body.scrollTop
  const scrollHeight = documentElement.scrollHeight || body.scrollHeight
  const clientHeight = documentElement.clientHeight
  return (scrollTop / (scrollHeight - clientHeight)) * 100
}

interface PageScrollTrackerProps {
  percentageThreshold: number
  onScrollThresholdPassed: () => void
}

const PageScrollTracker = ({
  percentageThreshold,
  onScrollThresholdPassed
}: PageScrollTrackerProps): JSX.Element => {
  let ticking
  const unregisterPageScrollListener = useRef(null)
  const onPageScroll = () => {
    if (!ticking) {
      raf(() => {
        const scrollPercentage = computePageScrollPercentage()
        if (scrollPercentage >= percentageThreshold) {
          onScrollThresholdPassed()
        }
        ticking = false
      })
      ticking = true
    }
  }

  useEffect(() => {
    unregisterPageScrollListener.current =
      registerPageScrollEventListener(onPageScroll)

    return () => {
      unregisterPageScrollListener.current &&
        unregisterPageScrollListener.current()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}

export default PageScrollTracker
